module.exports = __webpack_public_path__ + "img/banner3.fe349440.jpg";